document.addEventListener('DOMContentLoaded', () => {
  const addCheckoutSourceAttribute = async () => {
    try {
      const response = await fetch(`${window.themeVariables.routes.rootUrl}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { checkout_source: 'online_store' } })
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error('Error updating cart attributes:', error);
    }
  };

  // check for convert script auto updating cart attributes at the same time
  // add a delay if so
  if (window.convert?.shopifyCartUpdate?.request) {
    setTimeout(addCheckoutSourceAttribute, 4000);
  }
  else {
    addCheckoutSourceAttribute();
  }
})